// extracted by mini-css-extract-plugin
module.exports = {"new_infos":"TopNews_new_infos__uTimf","new_info":"TopNews_new_info__1fwBT","more":"TopNews_more__1wPdh"};